import { IELTData } from 'legacy/lut/classes/models/partner360/ELT/IELTData'
import { TEltFormData } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'

import { toServerFormat } from 'core/classes/helpers/DateHelper'

import { getSaveBasicData } from './getSaveBasicData'

interface ISave {
  data: IELTData | undefined
  formData: TEltFormData
  additionalData: Partial<IELTData>
  userEmail: string
  hasModifiedData?: boolean
}
export const save = async ({
  data,
  additionalData,
  formData,
  userEmail,
  hasModifiedData = true,
}: ISave) => {
  const { saveData, crud } = getSaveBasicData(data, formData, additionalData)

  const versionData = {
    ...saveData,
    VersionName: saveData.VersionName || 'Original',
    Version: saveData.Version || 1,
  } as IELTData
  if (hasModifiedData) {
    versionData.FormModifiedBy = userEmail
    versionData.FormModified = toServerFormat(new Date())
  }
  const isExistEntryId = saveData.EntryId && saveData.EntryId !== -1
  const method: 'create' | 'update' = isExistEntryId ? 'update' : 'create'
  return crud[method]({ formId: '1233', code: 'executive-leadership-team-1233' }, [versionData])
}
